import styled from 'styled-components'
import { ZingTheme } from '../../../assets/theme/types'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
export const PopUpHeader = styled.div`
  background-color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  height: 55px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 24px;
`
export const PopUpTitle = styled.h4`
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
  font-size: 20px;
  margin-top: 1rem;
  margin-bottom: 1rem;
`
export const PopUpContent = styled.div`
  min-height: 100px;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: pre-line;
  padding: 12px;
  gap: 8px;
`
export const PopUpParagraph = styled.span`
  font-size: 16px;
  line-height: 18.75px;
  color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
  overflow: auto;
  width: 100%;
`
export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
`

export const Label = styled.label`
  font-size: 16px;
  font-family: Sundry;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  color: ${({ theme }) => (theme as ZingTheme).colors.textPrimary};
  text-align: left;
`
export const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid ${({ theme }) => (theme as ZingTheme).colors.border};
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  outline: none;
  background: ${({ theme }) => (theme as ZingTheme).colors.white};
  color: ${({ theme }) => (theme as ZingTheme).colors.textPrimary};
  resize: vertical;

  &::placeholder {
    color: ${({ theme }) => (theme as ZingTheme).colors.grey400};
  }

  &:focus {
    border-color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
    box-shadow: 0 0 0 3px ${({ theme }) => (theme as ZingTheme).colors.indigoShadow};
  }

  &:disabled {
    background: ${({ theme }) => (theme as ZingTheme).colors.grey50};
    color: ${({ theme }) => (theme as ZingTheme).colors.border};
  }
`
export const Input = styled.input`
  width: 100%;
  border: 1px solid ${({ theme }) => (theme as ZingTheme).colors.border};
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  outline: none;
  background: ${({ theme }) => (theme as ZingTheme).colors.white};
  color: ${({ theme }) => (theme as ZingTheme).colors.textPrimary};

  &::placeholder {
    color: ${({ theme }) => (theme as ZingTheme).colors.grey400};
  }

  &:focus {
    border-color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
    box-shadow: 0 0 0 3px ${({ theme }) => (theme as ZingTheme).colors.indigoShadow};
  }

  &:disabled {
    background: ${({ theme }) => (theme as ZingTheme).colors.grey50};
    color: ${({ theme }) => (theme as ZingTheme).colors.border};
  }
`
